import React, { Component } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { translate, Trans } from 'react-i18next';
import { Link, Route } from 'react-router-dom';
import OLCollection from 'ol/collection';

import {
  TileLayer,
  BingSource,
  VectorLayer,
  VectorSource,
  ClusterSource,
} from '../ol';

import MapWithRouter from '../containers/MapWithRouter';
import ProfileDeviceSelectSideBar from '../profiles/DeviceSelectSideBar';
import ScheduleDeviceSelectSideBar from '../schedules/DeviceSelectSideBar';

import Select from '../ol/interactions/Select';
import DragBox from '../ol/interactions/DragBox';
import Draw from '../ol/interactions/Draw';
import Button from '../layout/Button';
import Loading from '../layout/Loading';
import InfoWindow from '../devices/InfoWindow';

import {
  defaultProfileStyles,
  activeProfileStyles
} from '../../mapStyles';

import { toFeature } from '../../reducers/devices';

import { Icon } from '../icons';
import styles from './deviceselect.scss';

class DeviceSelect extends Component {
  constructor(props) {
    super(props);
    this.featureCollection = new OLCollection(
      props.selectedDeviceIds.map(d_id => toFeature(props.devices.find(d => d.id === d_id))),
      { unique: true }
    );


    this.state = {
      thisProfileFeatures: [],
      selectableFeatures: [],
      show: false
    }

    this.selectFeaturesByExtent = this.selectFeaturesByExtent.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onDrawEnd = this.onDrawEnd.bind(this);
    this.onBoxEnd = this.onBoxEnd.bind(this);
    this.isFeatureSelectable = this.isFeatureSelectable.bind(this);
  }

  componentDidMount() {
    const { devices, activeCondition, selectableCondition } = this.props;

    this.setState({
      thisProfileFeatures: devices.filter(activeCondition).map(toFeature),
      selectableFeatures: devices.filter(selectableCondition).map(toFeature),
      show: !this.state.show
    });
  }

  componentWillUnmount(callback) {
    const { onClearDeviceSelection } = this.props;
    onClearDeviceSelection();
  }

  isFeatureSelectable(f) {
    // TODO: f.get('profile_id') because this f-ing drawing dot is also a feature...
    return f.get('profile_id') && this.state.thisProfileFeatures.indexOf(f) === -1
  }

  onBoxEnd(e) {
    var extent = e.target.getGeometry().getExtent();
    this.selectFeaturesByExtent(extent);
  }

  onDrawEnd(e) {
    const { onSelectDevices } = this.props;

    var polygon = e.feature.getGeometry();
	  var features = this.refs.selectableFeatures.vectorSource.getFeatures();
    let featuresToAdd = [];
  	for (var i = 0 ; i < features.length; i++){
  		if(polygon.intersectsExtent(features[i].getGeometry().getExtent())){
  			featuresToAdd.push(features[i]);
  		}
  	}
    featuresToAdd = featuresToAdd.filter(f => this.featureCollection.getArray().indexOf(f) === -1)
    this.featureCollection.extend(featuresToAdd);
    onSelectDevices(featuresToAdd.map(f => f.get('id')));
  }

  selectFeaturesByExtent(extent) {
    const { onSelectDevices } = this.props;
    const featuresToAdd = this.refs.selectableFeatures.vectorSource.getFeaturesInExtent(extent).filter(f =>
      this.featureCollection.getArray().indexOf(f) === -1
    );
    this.featureCollection.extend(featuresToAdd);
    onSelectDevices(featuresToAdd.map(f => f.get('id')));
  }

  onSelect(e) {
    const { onSelectDevices, onUnselectDevices } = this.props;

    onSelectDevices(e.selected.map(f => f.get('id')))
    onUnselectDevices(e.deselected.map(f => f.get('id')))
  }

  shouldComponentUpdate() {
    const { processingSelection } = this.props;
    // if (processingSelection) return false;
    return true;
  }

  render() {
    const {
      t,
      selectedProfile,
      selectedDevices,
      selectedDeviceCount,
      onSaveSelectedDevices,
      match,
      location,
      activeTab,
      onSetActiveTab,
      processingSelection,
      onCancelClick,
      children,
      tileMode,
      onTileModeChange,
      onFeatureHover,
      history } = this.props;

    const {
      thisProfileFeatures,
      selectableFeatures,
      electedFeatures,
      zoom,
      center
    } = this.state;

    const moreSelectedDevices = selectedDeviceCount - 20;

    return (
      <div>
        <CSSTransition key="profiles" timeout={800} classNames="slide-selected-profiles" in={this.state.show}>
          <div className="selected-profile-container">
            <Route path="/organisations/:organisationId/profiles/:profileId/devices" render={({ match }) => {
              return (<ProfileDeviceSelectSideBar profileId={match.params.profileId} />)
            }} />
            <Route path="/organisations/:organisationId/events/:eventId/schedules/:scheduleId" render={({ match }) => {
              return (<ScheduleDeviceSelectSideBar eventId={match.params.eventId} scheduleId={match.params.scheduleId} />)
            }} />
            <label htmlFor="tileMode"><h2 className="sidebar-heading">{t('MAP_MODE')}</h2></label>
            <select name="tileMode" onChange={onTileModeChange} value={tileMode}>
              {['canvas', 'satellite', 'road'].map(mode => <option key={mode} value={mode}>{mode}</option>)}
            </select>
            <div>
              <h2 className="sidebar-heading">{t('SELECTION_TIP_TITLE')}:</h2>
              <div className="selection-tip">{t('SELECTION_TIP_DESCRIPTION')}</div>
            </div>
          </div>
        </CSSTransition>

        <CSSTransition key="devices" timeout={800} classNames="slide-selected-devices" in={this.state.show}>
          <div className="selected-devices-container">
            <h2>{t('SELECTED_DEVICES')}</h2>
            {selectedDeviceCount === 0 ? (
              <div className="selected-devices-notice">{t('SELECTED_DEVICES_NOTE')}</div>
            ) : (
              <ul className="selected-devices-list">
                <TransitionGroup>
                  {selectedDevices.map((d) =>
                    <CSSTransition key={d.id} timeout={500} classNames="fade-item">
                      <li>
                        <div className="selected-device-icon">
                          <Icon type={'circle'} />
                        </div>
                        <div className="selected-device-name">
                          {d.name}
                        </div>
                      </li>
                    </CSSTransition>
                  )}
                </TransitionGroup>
                {selectedDeviceCount > 20 &&
                  <li>
                    <Trans i18nKey="SELECTED_COUNT">
                      And {{moreSelectedDevices}} more...
                    </Trans>
                  </li>
                }
              </ul>
            )}
            {!processingSelection && // we might want to set "disabled" state on the buttons instead of hiding in total
              <div className="selected-buttons">
                <Button onClick={onCancelClick} className="btn hollow">{t('CANCEL')}</Button>
                {selectedDevices.length > 0 ? <Button onClick={onSaveSelectedDevices} className="selected-save-btn">{t('SAVE_CHANGES')}</Button> : null}
              </div>
            }
          </div>
        </CSSTransition>
        {processingSelection && <Loading text="Processing selection..." />}
        {!processingSelection &&
          <MapWithRouter onFeatureHover={onFeatureHover} location={location} history={history}>
            <TileLayer opacity={tileMode === "satellite" ? 1 : 0}>
              <BingSource
                apiKey="AkPQjO5c6rlGFZF_PBGt77p7flbuLqSfvOcpwdaaMPIoOVZuiPN_PuR3omBFeICO"
                imagerySet="Aerial"
                maxZoom={19} />
            </TileLayer>
            <TileLayer opacity={tileMode === "canvas" ? 1 : 0}>
              <BingSource
                apiKey="AkPQjO5c6rlGFZF_PBGt77p7flbuLqSfvOcpwdaaMPIoOVZuiPN_PuR3omBFeICO"
                imagerySet="CanvasGray"
                maxZoom={19} />
            </TileLayer>
            <TileLayer opacity={tileMode === "road" ? 1 : 0}>
              <BingSource
                apiKey="AkPQjO5c6rlGFZF_PBGt77p7flbuLqSfvOcpwdaaMPIoOVZuiPN_PuR3omBFeICO"
                imagerySet="Road"
                maxZoom={19} />
            </TileLayer>

            <VectorLayer visible={true} style={defaultProfileStyles}>
              <VectorSource ref="selectableFeatures" features={selectableFeatures} />
            </VectorLayer>
            <VectorLayer visible={true} style={activeProfileStyles}>
              <VectorSource features={thisProfileFeatures} />
            </VectorLayer>
            <Select filter={(f, l) => this.isFeatureSelectable(f)} onSelect={this.onSelect} features={this.featureCollection} active={true} />
            {/*<DragBox onBoxEnd={this.onBoxEnd} />*/}
            <Draw onDrawEnd={this.onDrawEnd} />
            <InfoWindow />
          </MapWithRouter>
        }
      </div>
    )
  }
}

export default translate('device selection')(DeviceSelect);



// WEBPACK FOOTER //
// ./src/components/layout/DeviceSelect.js